import MenuManager from '@yooink/youtils/es/MenuManager';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useLoadComponent } from '@yooink/youtils/es/hooks/useLoadComponent';
import { YoProcent } from '../../Components/Icons/YoProcent';

MenuManager.RegisterGroup({
	key: 'promocodes',
	name: 'Промокоды и сертификаты',
	icon: <YoProcent />,
	position: 7
}, [{
	path: '/promocodes',
	name: 'Промокоды'
}, {
	path: '/promocodes/certificates',
	name: 'Сертификаты'
}, {
	path: '/promocodes/promoCertificates',
	name: 'Промо-сертификаты'
}]);

const PromocodesRoute = (props) => {
	const basePath = props.path || '/promocodes';
	const getPath = (path = '') => `${basePath}${path}`;

	const List = useLoadComponent(() => import('./Promocodes/List').then((res) => res.List), {
		basePath
	});
	const View = useLoadComponent(() => import('./Promocodes/View').then((res) => res.Edit), {
		basePath
	});
	const pms = useLoadComponent(() => import('./Promocodes/MassPromocodeCreator').then((res) => res.MassPromocodeCreator), {
		basePath
	});

	const psms = useLoadComponent(() => import('./PromoCertificates/MassPromocodeCreator').then((res) => res.MassPromoCertificateCreator), {
		basePath
	});

	const Presets = useLoadComponent(() => import('./Presets/presetsRoute').then((res) => res.PresetsRoute), {
		path: getPath('/presets')
	});

	const certificatesList = useLoadComponent(() => import('./Certifacates/List').then((res) => res.List), {
		basePath: getPath('/certificates')
	});
	const certificatesView = useLoadComponent(() => import('./Certifacates/View').then((res) => res.Edit), {
		basePath: getPath('/certificates')
	});

	const promoCertificatesList = useLoadComponent(() => import('./PromoCertificates/List').then((res) => res.List), {
		basePath: getPath('/promoCertificates')
	});
	const promoCertificatesView = useLoadComponent(() => import('./PromoCertificates/View').then((res) => res.Edit), {
		basePath: getPath('/promoCertificates')
	});

	return (
		<>
			<Route
				exact
				path={getPath()}
				component={List}
			/>
			<Switch>
				<Route
					exact
					path={getPath('/promoCertificates')}
					component={promoCertificatesList}
				/>
				<Route
					exact
					path={getPath('/promoCertificates/massCreator')}
					component={psms}
				/>
				<Route
					exact
					path={getPath('/promoCertificates/:id')}
					component={promoCertificatesView}
				/>
				<Route
					exact
					path={getPath('/certificates')}
					component={certificatesList}
				/>
				<Route
					exact
					path={getPath('/certificates/:id')}
					component={certificatesView}
				/>
				<Route
					path={getPath('/presets')}
					component={Presets}
				/>
				<Route
					exact
					path={getPath('/massCreator')}
					component={pms}
				/>
				<Route
					exact
					path={getPath('/:id')}
					component={View}
				/>
			</Switch>
		</>
	);
};

PromocodesRoute.propTypes = {
	path: PropTypes.string
};

export { PromocodesRoute };
